/**
 * Component: Size guide
 * ------------------------------------------------------------------------------
 * A size guide component.
 *
 * @namespace sizeGuide
 */
import { on } from '../helpers/utils';
import cssClasses from '~/helpers/cssClasses';
/**
 * DOM selectors.
 */

const selectors = {
  closeModal: '[js-size-guide="closeModal"]',
  container: '[js-size-guide="container"]',
  overlay: '[js-size-guide="overlay"]'
};
/**
 * Create a new size guide object.
 */

export default (() => {
  /**
   * DOM node selectors.
   */
  const nodeSelectors = {
    closeModal: document.querySelector(selectors.closeModal),
    container: document.querySelector(selectors.container),
    overlay: document.querySelector(selectors.overlay)
  };
  /**
   * Initialise component.
   */

  function init() {
    if (!nodeSelectors.container) {
      return;
    }

    setEventListeners();
  }
  /**
   * Set event listeners.
   */


  function setEventListeners() {
    on('click', nodeSelectors.closeModal, () => handleCloseSizeGuide());
    on('click', nodeSelectors.overlay, () => handleCloseSizeGuide());
  }
  /**
   * Handle closing size guide.
   */


  function handleCloseSizeGuide() {
    nodeSelectors.container.classList.remove(cssClasses.active);
  }
  /**
   * Expose public interface.
   */


  return Object.freeze({
    init,
    handleCloseSizeGuide
  });
});